import { Link } from "react-router-dom";
import LogoImage from "@/assets/img/logo.png";

interface Props {
  className?: string;
  size?: string;
}

export default function Logo({ className = "", size = "h-9" }: Props) {
  return (
    <Link to="/" className={className}>
      <img className={`${size} w-auto mx-auto`} src={LogoImage} alt="Logo" />
    </Link>
  );
}
